import { type FormEvent, type KeyboardEvent, type RefObject } from "react";
import { EonUiIcon } from "@eon-ui/eon-ui-components-react";

interface SearchInputBoxProps {
    value: string;
    setValue: (value: string) => void;
    submit: () => void;
    isSubmitting?: boolean;
    textareaRef?: RefObject<HTMLTextAreaElement>;
    onKeyDown?: (event: KeyboardEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    rows?: number;
    fullWidth?: boolean;
}

export default function SearchInputBox({
    value,
    setValue,
    submit,
    isSubmitting = false,
    textareaRef,
    onKeyDown,
    placeholder = "Ask about the queue, or say what to approve or decline...",
    rows = 1,
    fullWidth = false,
}: SearchInputBoxProps) {
    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!isSubmitting) {
            submit();
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLTextAreaElement>) => {
        if (onKeyDown) {
            onKeyDown(event);
            return;
        }

        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            if (!isSubmitting) {
                submit();
            }
        }
    };

    return (
        <form
            className={`search-shell${fullWidth ? " search-shell--full-width" : ""}`}
            onSubmit={handleSubmit}
        >
            <div className="search-box">
                <textarea
                    ref={textareaRef}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={placeholder}
                    rows={rows}
                />
                <button
                    type="submit"
                    className="search-send"
                    disabled={!value.trim() || isSubmitting}
                    aria-label="Send message"
                >
                    <EonUiIcon title="send" size="small" name="send" />
                </button>
            </div>
        </form>
    );
}
